import { render } from "./NotificationsPage.vue?vue&type=template&id=7e251b1c&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=7e251b1c&lang=css"
import "./NotificationsPage.vue?vue&type=style&index=1&id=7e251b1c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e251b1c"]])

export default __exports__